import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.enableProd) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

/** Definizione del metodo che ritorna la data in JSON per l'invio verso webapi. Mantiene il timezone delle date */
Date.prototype.toJSON = function (): string {
  const pad = (n: any, size: number = 2) => n.toString().padStart(size, '0');
  return `${this.getFullYear()}-${pad(this.getMonth() + 1)}-${pad(this.getDate())}T` +
    `${pad(this.getHours())}:${pad(this.getMinutes())}:${pad(this.getSeconds())}`;
}

/** Definizione del metodo che ritorna il primo giorno della settimana rispetto alla data */
Date.prototype.getFirstDayOfWeek = function (): Date {
  return new Date(new Date(this.setDate(this.getDate() - this.getDay() + (this.getDay() == 0 ? -6 : 1))).setHours(0, 0, 0, 0));
}

/** Definizione del metodo che ritorna l'ultimo giorno della settimana rispetto alla data */
Date.prototype.getLastDayOfWeek = function (): Date {
  return new Date(new Date(this.setDate(this.getDate() - this.getDay() + 7)).setHours(0, 0, 0, 0));
}

/** Massima data ammessa */
Date.prototype.getMaxDate = function (): Date {
  return new Date(2079, 5, 6);
}

/** Definizione del metodo che ritorna la data senza orario  */
Date.prototype.getPlainDate = function (): Date {
  const ret = (new Date(this));
  ret.setHours(0, 0, 0, 0)

  return ret;
}

/** Definizione del metodo che aggiunge n giorni alla data */
Date.prototype.addDays = function (days: number, plainDate: boolean = true): Date {
  let date = new Date(this);
  if (plainDate) {
    if (date && date.getPlainDate) {
      date = date.getPlainDate();
    }
  }

  return new Date(date.setDate(date.getDate() + days));
}

/** Definizione del metodo che aggiunge n minuti alla data */
Date.prototype.addMinutes = function (minutes: number): Date {
  return new Date(this.getTime() + minutes * 60000);
}

/** Definizione del metodo che ritorna la differenza tra due date  */
Date.prototype.getDiff = function (dateToCompare: Date, interval: 'milliseconds' | 'seconds' | 'minutes' | 'hours' | 'days' = 'days'): number {
  dateToCompare ??= new Date();

  const diffInMs = dateToCompare.getTime() - this.getTime()
  switch (interval) {
    case 'milliseconds':
      return diffInMs;
    case 'seconds':
      return diffInMs / 1000;
    case 'minutes':
      return diffInMs / (1000 * 60);
    case 'hours':
      return diffInMs / (1000 * 60 * 60);
    case 'days':
    default:
      return diffInMs / (1000 * 60 * 60 * 24);
  }
}

/** Definizione del metodo che ritorna il primo giorno del mese */
Date.prototype.getFirstDayOfMonth = function (): Date {
  return new Date(this.getFullYear(), this.getMonth(), 1).getPlainDate?.() ?? new Date(this.getFullYear(), this.getMonth(), 1);
}

/** Definizione del metodo che ritorna l'ultimo giorno del mese */
Date.prototype.getLastDayOfMonth = function (): Date {
  const plainDate = new Date(this.getFullYear(), this.getMonth() + 1, 0).getPlainDate?.();
  return plainDate ?? new Date(this.getFullYear(), this.getMonth() + 1, 0);
}

Number.prototype.MAX_INT32 = 9999999;

/**
 * Prima lettera maiuscola
 * https://flaviocopes.com/how-to-uppercase-first-letter-javascript/
 */
String.prototype.capitalize = function (): string {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

/**
 * Prima lettera minuscola
 * https://flaviocopes.com/how-to-uppercase-first-letter-javascript/
 */
String.prototype.uncapitalize = function (): string {
  return this.charAt(0).toLowerCase() + this.slice(1)
}
